import aghapi from '../../api/aghapi.js'
const WITH_DEL='WITH_DEL'
const WITH_ADD='WITH_ADD'
const WITH_REPLAY_ADD='WITH_REPLAY_ADD'
const WITH_REPLAY_DEL='WITH_REPLAY_DEL'
const WITH_LIST='WITH_LIST'
const WITH_IMAGE_LIST='WITH_IMAGE_LIST'
const BIRTHDAY_ALL_LIST='BIRTHDAY_ALL_LIST'
// const BIRTHDAY_WEEK_LIST='BIRTHDAY_WEEK_LIST'
const BIRTHDAY_WISH_DETAIL='BIRTHDAY_WISH_DETAIL'
const SEARCH_BIRTHDAY_ALL_LIST = 'SEARCH_BIRTHDAY_ALL_LIST'
const SET_SCROLL_IS_DISABLED = 'SET_SCROLL_IS_DISABLED'
const SET_SCROLL_IS_DISABLED_TRUE = 'SET_SCROLL_IS_DISABLED_TRUE'
const SET_SEARCH_SCROLL_IS_DISABLED = 'SET_SEARCH_SCROLL_IS_DISABLED'
const SET_SEARCH_BRITHDAY_SCROLL_LIST =  'SET_SEARCH_BRITHDAY_SCROLL_LIST'
const INIT_BIRTHDAY_ALL_LIST = 'INIT_BIRTHDAY_ALL_LIST'
const INIT_SEARCH_BIRTHDAY_LIST = 'INIT_SEARCH_BIRTHDAY_LIST'
const BIRTHDAY_PERSON_INFO='BIRTHDAY_PERSON_INFO'
// const SCROLL_BIRTHDAY_WEEK_LIST = 'SCROLL_BIRTHDAY_WEEK_LIST'
const BIRTHDAY_INTRO = 'BIRTHDAY_INTRO'
const BIRTHDAY_CARE_WELFARE = 'BIRTHDAY_CARE_WELFARE'
const SET_SEARCH_SCROLL_IS_DISABLED_TRUE  = 'SET_SEARCH_SCROLL_IS_DISABLED_TRUE'
const SET_BIRTHDAY_LOADING = 'SET_BIRTHDAY_LOADING'
const SET_ISMEMBER = 'SET_ISMEMBER'
const SET_LOADING ='SET_LOADING'
const GET_WALL_INFO = 'GET_WALL_INFO'
const GET_BIRTHDAY_NUM_LIST = 'GET_BIRTHDAY_NUM_LIST'
const QINIU_TOKEN ='QINIU_TOKEN'
const GET_BOARD_WISH_LIST = 'GET_BOARD_WISH_LIST'
const SUBMIT_BOARD_WISH_INFO = 'SUBMIT_BOARD_WISH_INFO'
const DEPARTMENT_LIST = "DEPARTMENT_LIST"
const USER_LIST = "USER_LIST"
const SEARCH_PARAMS = "SEARCH_PARAMS"
const LOAD_FINISH = "LOAD_FINISH"
const BIRTHDAY_DATA_USER_LIST = "BIRTHDAY_DATA_USER_LIST"
const CUR_POS_Y = "CUR_POS_Y"
const WEEK_PARAMS = "WEEK_PARAMS"
const WEEK_DATA_USER_LIST = "WEEK_DATA_USER_LIST"
const WEEK_CUR_POS_Y = "WEEK_CUR_POS_Y"
const CORP_INFO = "CORP_INFO"


const state = {
    delWish:{},
    addWish:{},
    delWishReply:{},
    addWishReply:{},
    wishList:{},
    wishImageList:{},
    birthdayAllList:{list:[],total:'',totalPage:''},
    birthdayWeekList:{list:[],total:'',totalPage:''},
    birthdayWishDetail:{},
    searchBirthdayAllList:{list:[],total:'',totalPage:''},
    scrollIsDisabled:true,
    searchScrollIsDisabled:true,
    birthdayWishDetail:{},
    birthdayPersonInfo:{},
    birthdayIntro:{},
    birthdayCareWelfare:{},
    birthdayLoading:true,
    isMember:true,
    loadingText: true,
    wallInfo:'',
    birthdayList:'',
    // qiniuToken:'',
    boardWishList:'',
    submitBoardWishInfo:'',
    departmentList:'',
    userList:null,
    searchParams:null,    // 生日贴士 请求参数
    loadFinish:null,
    birthdayDataUserList:null,  // 生日贴士 用户列表数据
    curPosY:null, // 生日贴士 用户列表页面跳转前的位置
    weekParams:null,    // 本周生日之星 请求参数
    weekDataUserList:null,  // 本周生日之星 列表数据
    weekCurPosY:null, // 本周生日之星 列表页面跳转前的位置
    corpInfo:{}
}

// getters
const getters = {
    getDelWish:state=>{return state.delWish},
    getAddWish:state=>{return state.addWish},
    getDelWishReply:state=>{return state.delWishReply},
    getAddWishReply:state=>{return state.addWishReply},
    getWishList:state=>{return state.wishList},
    getWishImageList:state=>{return state.wishImageList},
    getBirthdayAllList:state=>{return state.birthdayAllList},
    getBirthdayWeekList:state=>{return state.birthdayWeekList},
    getBirthdayWishDetail:state=>{return state.birthdayWishDetail},
    searchBirthdayAllList:state=>{return state.searchBirthdayAllList},
    scrollIsDisabled:state=>{return state.scrollIsDisabled},
    searchScrollIsDisabled:state=>{return state.searchScrollIsDisabled},
    getBirthdayPersonInfo:state=>{return state.birthdayPersonInfo},
    getBirthdayIntro:state=>{return state.birthdayIntro},
    getBirthdayCareWelfare:state=>{return state.birthdayCareWelfare},
    getBirthdayLoading:state=>{return state.birthdayLoading},
    getIsMember:state=>{return state.isMember},
    loadingText:state=>{return state.loadingText},
    getWallInfo:state => {return state.wallInfo},
    getBirthdayList:state => {return state.birthdayList},
    // getQiniuToken:state=>{return state.qiniuToken},
    getBoardWishList: state=> {return state.boardWishList},
    getSubmitBoardWishInfo: state => {return state.submitBoardWishInfo},
    getDepartmentList: state => {return state.departmentList},
    userList: state => {return state.userList},
    searchParams: state => {return state.searchParams},
    loadFinish: state => {return state.loadFinish},
    birthdayDataUserList: state => {return state.birthdayDataUserList},
    curPosY: state => {return state.curPosY},
    weekParams: state => {return state.weekParams},
    weekDataUserList: state => {return state.weekDataUserList},
    weekCurPosY: state => {return state.weekCurPosY},
    corpInfo:state=>{return state.corpInfo},
}

// actions
const actions = {
    doDelWish({commit},params){
        aghapi.birthdayWishDel(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                let date=new Date().getTime();
                commit(WITH_DEL,{data:date})

                aghapi.birthdayPersonInfo({subUid:state.birthdayPersonInfo.subUid}).then((res)=>{
                    if(res.data&&res.data.errno==0){
                        commit(BIRTHDAY_PERSON_INFO,{data:res.data.body})
                    }
                })
            }
        })
    },
    doBirthdayWishAdd({commit},params){
    	aghapi.birthdayWishAdd(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
                let date=new Date().getTime();
                commit(WITH_ADD,{data:date})
                try {   
                    aghapi.birthdayPersonInfo({subUid:state.birthdayPersonInfo.subUid}).then((res)=>{
                        if(res.data&&res.data.errno==0){
                            commit(BIRTHDAY_PERSON_INFO,{data:res.data.body})
                        }
                    })
                } catch (error) {
                    console.log(error)
                }
    		}else if(res.data.errno == 1001001011){
                commit(WITH_ADD,{data:null})
            }else{
                let error="error"+new Date().getTime();
                commit(WITH_ADD,{data:error})
            }
            
    	})
    },
    doBirthdayWishReplyDel({commit},params){
    	aghapi.birthdayWishReplyDel(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
                let date=new Date().getTime();
                console.log("del",res)
    			commit(WITH_REPLAY_DEL,{data:date})
    		}
    	})
    },
    doBirthdayWishReplyAdd({commit},params){
    	aghapi.birthdayWishReplyAdd(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
                let date=new Date().getTime();
    			commit(WITH_REPLAY_ADD,{data:date})
    		}
    	})
    },
    doBirthdayWishList({commit},params){
    	aghapi.birthdayWishList(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
    			commit(WITH_LIST,{data:res.data.body})
    		}
    	})
    },
    doBirthdayWishImageList({commit},params){
    	aghapi.birthdayWishImageList(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
    			commit(WITH_IMAGE_LIST,{data:res.data.body})
    		}
    	})
    },
    doBirthdayAllList({commit},params){
    	aghapi.birthdayAllList(params).then((res)=>{
    	    console.log(res.data.errno)
    		if(res.data&&res.data.errno==0){
    		    //
                commit(SET_BIRTHDAY_LOADING)
                if (res.data.body.total === 0) {
                    commit(SET_SCROLL_IS_DISABLED_TRUE)
                    console.log(false)
                }else {
                    commit(BIRTHDAY_ALL_LIST,{data:res.data.body})
                    commit(SET_LOADING,false)

                    setTimeout(function () {
                        commit(SET_SCROLL_IS_DISABLED)
                    },2000)
                }

    		}else if (res.data.errno ==1001001003) {
                commit(SET_BIRTHDAY_LOADING)
                commit(SET_ISMEMBER,false)
            }
    	})
    },
    doSearchBirthdayAllList({commit},params,type){
        aghapi.birthdaySearchList(params.data).then((res)=>{
            if(res.data&&res.data.errno==0){
                setTimeout(function () {
                    commit(SET_SEARCH_SCROLL_IS_DISABLED)
                },2000)
                if (params.type === 'normal'){
                    commit(SEARCH_BIRTHDAY_ALL_LIST,{data:res.data.body})
                }else if (params.type === 'scroll') {
                    commit(SET_SEARCH_BRITHDAY_SCROLL_LIST,{data:res.data.body})
                }
            }
        })
    },
    // doBirthdayWeekList({commit},params){
    //     aghapi.birthdayWeekList(params.data).then((res)=>{
    //         if(res.data&&res.data.errno==0){
    //             commit(SET_SCROLL_IS_DISABLED)
    //             if (params.type === 'normal') {
    //                 commit(BIRTHDAY_WEEK_LIST,{data:res.data.body})
    //             }else if (params.type === 'scroll'){
    //                 commit(SCROLL_BIRTHDAY_WEEK_LIST,{data:res.data.body})
    //             }
    //         }
    //     })
    // },
    doBirthdayWishDetail({commit},params){
        aghapi.birthdayWishDetail(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(BIRTHDAY_WISH_DETAIL,{data:res.data.body})
            }
            if(res.data&&res.data.errno==1001001002){
               let date=new Date().getTime();
               let error="error"+date;
               commit(BIRTHDAY_WISH_DETAIL,{data:error})
            }
        })
    },
    doBirthdayPersonInfo({commit},params){
    	aghapi.birthdayPersonInfo(params).then((res)=>{
    		if(res.data&&res.data.errno==0){
    			commit(BIRTHDAY_PERSON_INFO,{data:res.data.body})
    		}
            if(res.data&&res.data.errno==1001001003){
               let date=new Date().getTime();
               let error="error"+date;
               commit(BIRTHDAY_PERSON_INFO,{data:error})
            }
            if(res.data.errno==1001001010){
                commit(BIRTHDAY_PERSON_INFO,{data:null})
            }
    	})
    },
    setAllListScroll ({commit}){
        commit(SET_SCROLL_IS_DISABLED_TRUE)
    },
    setSearchListScroll ({commit}){
        commit(SET_SEARCH_SCROLL_IS_DISABLED_TRUE)
    },
    initBirthdayAllList({commit}) {
      commit(INIT_BIRTHDAY_ALL_LIST)
    },
    initSearchBirthdayList({commit}){
        commit(INIT_SEARCH_BIRTHDAY_LIST)
    },
    doBirthdayIntro({commit},params){
        aghapi.birthdayCheckUserGuide(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(BIRTHDAY_INTRO,{data:res.data.body})

            }
        })
    },
    getBirthdayCareWelfare({commit},params){
        aghapi.birthdayCaresWelfare(params).then((res)=>{
            if(res.data&&res.data.errno==0){
                commit(BIRTHDAY_CARE_WELFARE,{data:res.data.body})

            }
        })
    },
    setLoadingText({commit}) {
        commit (SET_LOADING,true)
    },
    getWishWallInfo ({ commit},params) {  //  获取祝福墙信息
        aghapi.getWishWallInfo(params).then((res)=> {
            console.log(res)
            if (res.data &&res.data.errno ===0) {
                commit (GET_WALL_INFO,{data:res.data.body})
            }
        })
    },
    getWishList ({ commit },params) {
        aghapi.getWishList(params).then((res) => {
            console.log(res)
            if (res.data &&res.data.errno ===0) {
                // commit (GET_WALL_IMAGES,{data:res.data.body})
            }
        })
    },
    getBirthdayList ({ commit }, params) {
        aghapi.getBirthdayNum(params).then((res) => {
            console.log('birthdayList',res)
            if (res.data &&  res.data.errno ==0) {
                commit(GET_BIRTHDAY_NUM_LIST,{data:res.data.body.list})
            }
        })
    },

    // requestQiniuToken({commit},params) {
    //     aghapi.getToken(params,function(error,res){
    //         if(!error){
    //             commit(QINIU_TOKEN,{data:res})
    //         }
    //     })
    // },
    getBoardWishList ({ commit }, params) {
        aghapi.getWishList(params).then((res) => {
            console.log('祝福列表',res.data.body)
            if(res.data && res.data.errno === 0 ) {
                commit(GET_BOARD_WISH_LIST,{data:res.data.body})
            }
        })
    },
    submitWish({ commit }, params) {
        aghapi.addBoardWish(params).then((res) => {
            console.log(res)
            if(res.data && res.data.errno == 0) {
                let data = {
                    errno : res.data.errno,
                    date:Math.random()
                }
                commit(SUBMIT_BOARD_WISH_INFO,data)
            } else {
                console.log(res.data.error)
                commit (SUBMIT_BOARD_WISH_INFO,res.data.error)
            }

        })
    },
    getDepartmentList({ commit }, params) {
        aghapi.departmentList(params).then((res) => {
            if (res.data &&  res.data.errno ==0) {
                commit(DEPARTMENT_LIST,res.data.body)
            }
        })
    },
    getCorpInfo({ commit }, params){
        return aghapi.getCorpInfo(params).then( res=>{
            console.log(res)
            if (res.data &&  res.data.errno ==0) {
                commit(CORP_INFO,res.data.body)
            }
        })
    },
    getUserList({ commit }, params){
        console.log('params',params)
        aghapi.getUserList(params).then((res) => {
            if (res.data &&  res.data.errno ==0) {
                commit(USER_LIST,res.data.body)
            }
        })
    },
    setSearchParams({ commit }, searchParams){
        let data = $.extend(true, {}, searchParams);
        commit(SEARCH_PARAMS, data)
    },
    setLoadFinish({ commit }, loadFinish){
        let data = $.extend(true, {}, loadFinish);
        commit(LOAD_FINISH, data)
    },
    setBirthdayDataUserList({ commit }, birthdayDataUserList){
        let data = $.extend(true, {}, birthdayDataUserList);
        commit(BIRTHDAY_DATA_USER_LIST, data)
    },
    setCurPosY({ commit }, curPosY){
        let data = $.extend(true, {}, curPosY);
        commit(CUR_POS_Y, data)
    },
    setWeekParams({ commit }, weekParams){
        let data = $.extend(true, {}, weekParams);
        commit(WEEK_PARAMS, data)
    },
    setWeekDataUserList({ commit }, weekDataUserList){
        let data = $.extend(true, {}, weekDataUserList);
        commit(WEEK_DATA_USER_LIST, data)
    },
    setWeekCurPosY({ commit }, weekCurPosY){
        let data = $.extend(true, {}, weekCurPosY);
        commit(WEEK_CUR_POS_Y, data)
    }

}

// mutations
const mutations = {
    [WITH_DEL](state, { data }) {
        state.delWish = data
    },
    [WITH_ADD](state, { data }) {
        state.addWish = data
    },
    [WITH_REPLAY_DEL](state, { data }) {
        state.delWishReply = data
    },
    [WITH_REPLAY_ADD](state, { data }) {
        state.addWishReply = data
    },
    [WITH_LIST](state, { data }) {
        state.wishList = data
    },
    [WITH_IMAGE_LIST](state, { data }) {
        state.wishImageList = data
    },
    [SET_ISMEMBER](state,data) {
      state.isMember = data
    },
    [BIRTHDAY_ALL_LIST](state, { data }) {
        state.birthdayAllList.list = state.birthdayAllList.list.concat(data.list)
        state.birthdayAllList.total = data.total
        state.birthdayAllList.totalPage = data.totalPage
    },
    [SET_BIRTHDAY_LOADING](state) {
        state.birthdayLoading = false
    },
    // [BIRTHDAY_WEEK_LIST](state, { data }) {
    //     state.birthdayWeekList=data
    // },
    // [SCROLL_BIRTHDAY_WEEK_LIST](state, {data}) {
    //     state.birthdayWeekList.list=state.birthdayWeekList.list.concat(data.list)
    // },
    [BIRTHDAY_WISH_DETAIL](state, { data }) {
        state.birthdayWishDetail = data
    },
    [SEARCH_BIRTHDAY_ALL_LIST](state, {data}) {
        state.searchBirthdayAllList.list =data.list
        state.searchBirthdayAllList.taotal =data.total
        state.searchBirthdayAllList.totalPage =data.totalPage
    },
    [SET_SEARCH_BRITHDAY_SCROLL_LIST](state,{data}) {
        state.searchBirthdayAllList.list = state.searchBirthdayAllList.list.concat(data.list)
        state.searchBirthdayAllList.taotal =data.total
        state.searchBirthdayAllList.totalPage =data.totalPage
    },
    [SET_SCROLL_IS_DISABLED_TRUE](state){
        state.scrollIsDisabled = true
    },
    [SET_SCROLL_IS_DISABLED](state) {
        state.scrollIsDisabled = false
    },
    [SET_SEARCH_SCROLL_IS_DISABLED](state) {
        state.searchScrollIsDisabled=false
    },
    [SET_SEARCH_SCROLL_IS_DISABLED_TRUE](state) {
        state.searchScrollIsDisabled=true
    },
    [INIT_BIRTHDAY_ALL_LIST](state) {
      let arr = state.birthdayAllList.list
      arr.splice(0,arr.length)
    },
    [INIT_SEARCH_BIRTHDAY_LIST](state) {
        let arr = state.searchBirthdayAllList.list
        arr.splice(0,arr.length)
    },
    [BIRTHDAY_PERSON_INFO](state, { data }) {
        state.birthdayPersonInfo = data
    },
    [BIRTHDAY_INTRO](state, { data }) {
        state.birthdayIntro = data
    },
    [BIRTHDAY_CARE_WELFARE](state, { data }) {
        state.birthdayCareWelfare = data
    },
    [SET_LOADING] (state,data) {
        state.loadingText = data
    },

    [GET_WALL_INFO] (state, { data }) {
        state.wallInfo = data
    },
    [GET_BIRTHDAY_NUM_LIST] (state, {data}) {
        state.birthdayList = data
    },

    // [QINIU_TOKEN] (state,data) {
    //     state.qiniuToken = data
    // },
    [GET_BOARD_WISH_LIST] (state,{ data }) {
        state.boardWishList = data
    },
    [SUBMIT_BOARD_WISH_INFO] (state,data) {
        state.submitBoardWishInfo = data
    },
    [DEPARTMENT_LIST] (state,data) {
        state.departmentList = data
    },
    [CORP_INFO] (state,data) {
        state.corpInfo = data
    },
    [USER_LIST] (state,data) {
        state.userList = data
    },
    [SEARCH_PARAMS] (state,data) {
        state.searchParams = data
    },
    [LOAD_FINISH] (state,data) {
        state.loadFinish = data
    },
    [BIRTHDAY_DATA_USER_LIST] (state,data) {
        state.birthdayDataUserList = data
    },
    [CUR_POS_Y] (state,data) {
        state.curPosY = data
    },
    [WEEK_PARAMS] (state,data) {
        state.weekParams = data
    },
    [WEEK_DATA_USER_LIST] (state,data) {
        state.weekDataUserList = data
    },
    [WEEK_CUR_POS_Y] (state,data) {
        state.weekCurPosY = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}